module.exports = __webpack_public_path__ + "img/15.05c258db.jpg";